import type { LoadFailure } from '@pos/app/scripts/services/load-failure';
import { DataFeed } from '@core/app/scripts/services/data-feed';

export class Barcodes {
  constructor(
    private $log: ng.ILogService,
    private $q: ng.IQService,
    private dataFeed: DataFeed,
    private loadFailure: LoadFailure,
    private $translate: ng.translate.ITranslateService,
  ) {}

  db = {};
  loaded = false;

  private setDataFeed = (dataFeedPromise) => {
    /* eslint-disable no-use-before-define */
    dataFeedPromise.then(
      (response) => {
        //Barcodes
        this.db = response.data;

        this.loaded = true;
      },
      (r) => {
        this.$log.error('[DataFeed] Something went wrong loading POSFeed');
        this.loadFailure(this.$translate.instant('datafeed'));

        return this.$q.reject(this.$translate.instant('datafeed'));
      },
    );
  };

  init = () => {
    this.setDataFeed(this.dataFeed.load());
  };

  reload = () => {
    this.setDataFeed(this.dataFeed.load(true));
  };

  contain = (barcode) => {
    return !!this.db[barcode];
  };

  get = (barcode) => {
    const data = this.db[barcode],
      processedProduct = {};

    if (!data) {
      return undefined;
    }

    processedProduct.price = parseFloat(data.d);
    processedProduct.saleprice = 0;

    if (data.k !== undefined) {
      processedProduct.saleprice = processedProduct.price;
      processedProduct.price = parseFloat(data.k);
    }

    processedProduct.sizeLabel = data.f;
    processedProduct.articleDescription = data.b;
    processedProduct.articleCode = data.i;
    processedProduct.group = data.e;
    processedProduct.brand = data.c;
    processedProduct.collection = data.t;
    processedProduct.error = data.error;
    processedProduct.color = `${data.n} ${data.s}`;
    processedProduct.vat = parseFloat(data.j);
    processedProduct.image = data.z;

    return processedProduct;
  };
}

/*
 * Service barcodes
 */
angular
  .module('posApp')
  .factory(
    'barcodes',
    (
      $log: ng.ILogService,
      $q: ng.IQService,
      dataFeed: DataFeed,
      loadFailure: LoadFailure,
      translate: ng.translate.ITranslateService,
    ) => {
      return new Barcodes($log, $q, dataFeed, loadFailure, translate);
    },
  );
